export default {
  'apps.title': 'Apps',
  'apps.subtitle': 'Create and manage AI-generated applications',
  'apps.empty': 'No applications',
  'apps.empty.description': 'Create your first application with the AI assistant',

  // Buttons
  'apps.button.create': 'Create App',
  'apps.button.open': 'Open',
  'apps.button.builder': 'Builder',
  'apps.button.preview': 'Preview',
  'apps.button.edit': 'Edit',
  'apps.button.delete': 'Delete',
  'apps.button.duplicate': 'Duplicate',
  'apps.button.copy': 'Copy',

  // Copy flow (preview + execute)
  'apps.copy.title': 'Copy App',
  'apps.copy.source.section': 'Source app',
  'apps.copy.target.section': 'Target',
  'apps.copy.targetCompany': 'Target company',
  'apps.copy.targetCompany.placeholder': 'Pick a company',
  'apps.copy.targetCompany.required': 'Target company is required',
  'apps.copy.targetEnvironment': 'Target environment',
  'apps.copy.targetEnvironment.placeholder': 'Pick an environment',
  'apps.copy.targetEnvironment.required': 'Target environment is required',
  'apps.copy.targetEnvironment.pickCompanyFirst': 'Pick a company first',

  'apps.copy.preview.button': 'Compute preview',
  'apps.copy.preview.computing': 'Computing preview...',
  'apps.copy.preview.ready': 'Preview ready — review below before copying',
  'apps.copy.preview.retry': 'Retry',
  'apps.copy.preview.section': 'Migration preview',
  'apps.copy.preview.sourceVersion': 'Source version',
  'apps.copy.preview.permissions': 'Permissions to copy',
  'apps.copy.preview.accessControl': 'Access control to copy',
  'apps.copy.preview.config': 'Configuration to copy',
  'apps.copy.preview.empty': 'No items',
  'apps.copy.preview.warnings': 'Warnings',
  'apps.copy.preview.noWarnings': 'No warnings',
  'apps.copy.preview.error': 'Could not compute preview',
  'apps.copy.preview.hint': 'Pick the target company and environment to see what will be copied.',

  'apps.copy.overrides.section': 'Copy customization',
  'apps.copy.newName': 'Name of the copy',
  'apps.copy.newName.placeholder': 'Name for the new app',
  'apps.copy.newName.required': 'New app name is required',
  'apps.copy.newDescription': 'Description',
  'apps.copy.newDescription.placeholder': 'Briefly describe the new app',

  'apps.copy.select.searchPlaceholder': 'Search...',
  'apps.copy.config.hint':
    'Copied as-is from the source. Edit the JSON if you need to remap identifiers or target-specific values.',
  'apps.copy.config.invalid': 'Invalid JSON',
  'apps.copy.config.beautify': 'Format',
  'apps.copy.version.label': 'Source version',
  'apps.copy.version.auto': 'Auto',
  'apps.copy.version.auto.hint': 'Latest published version',
  'apps.copy.version.current': 'current',
  'apps.copy.version.published': 'published',
  'apps.copy.source.label': 'Source app',
  'apps.copy.confirm': 'Copy app',
  'apps.copy.success': 'App copied successfully',
  'apps.copy.error': 'Error copying the app',
  'apps.copy.openBuilder': 'Open builder',
  'apps.copy.success.warningsHint': 'Notes to review in target',
  'apps.copy.success.moreWarnings': '+{count} more notes',
  'apps.copy.success.referencePermissions': 'Source permissions (reference)',
  'apps.copy.success.referenceAccessControl': 'Source access control (reference)',
  'apps.copy.success.referenceMore': '+{count} more',

  'apps.copy.warning.missing-reference-in-target':
    'Reference not available in target — review after copy',
  'apps.copy.warning.cross-company-permission-reference':
    'Cross-company permission — may not apply in target',
  'apps.copy.warning.config-guid-reference-review':
    'Hardcoded identifier in configuration — update it in target',
  'apps.copy.warning.unknown': 'Copy note',

  // Form
  'apps.form.name': 'Name',
  'apps.form.name.placeholder': 'Application name',
  'apps.form.name.required': 'Name is required',
  'apps.form.description': 'Description',
  'apps.form.description.placeholder': 'Briefly describe your application',
  'apps.form.icon': 'Icon',
  'apps.form.coverImage': 'Cover Image',
  'apps.form.isActive': 'Active',

  // Wizard steps
  'apps.wizard.steps.initial': 'Initial',
  'apps.wizard.steps.basicInformation': 'Basic Information',
  'apps.wizard.steps.personalization': 'Personalization',
  'apps.wizard.steps.manifest': 'Manifest',
  'apps.wizard.steps.login': 'Login',
  'apps.wizard.steps.appPermissions': 'Permissions',
  'apps.wizard.steps.appAccessControl': 'Access Control',

  // App Permissions (step 5)
  'apps.form.permissions.processes': 'Processes',
  'apps.form.permissions.process': 'Process',
  'apps.form.permissions.lists': 'Lists',
  'apps.form.permissions.list': 'List',
  'apps.form.permissions.reports': 'Reports',
  'apps.form.permissions.report': 'Report',
  'apps.form.permissions.entities': 'Entities',
  'apps.form.permissions.entity': 'Entity',
  'apps.form.permissions.aiAgents': 'AI agents',
  'apps.form.permissions.aiAgent': 'AI agent',
  'apps.form.permissions.connections': 'Connections',
  'apps.form.permissions.connection': 'Connection',

  // App Access Control (step 6)
  'apps.form.accessControl.users': 'Users',
  'apps.form.accessControl.user': 'User',
  'apps.form.accessControl.userGroups': 'User groups',
  'apps.form.accessControl.userGroup': 'User group',
  'apps.form.accessControl.positions': 'Positions',
  'apps.form.accessControl.position': 'Position',
  'apps.form.accessControl.areas': 'Areas',
  'apps.form.accessControl.area': 'Area',

  // Manifest
  'apps.form.manifestThemeColor': 'Theme color',
  'apps.form.manifestBackgroundColor': 'Background color',
  'apps.form.manifestIcon192x192': 'Icon 192x192',
  'apps.form.manifestIcon512x512': 'Icon 512x512',

  // Login
  'apps.form.loginLogo': 'Logo',
  'apps.form.loginSplash': 'Splash',
  'apps.form.loginMainColor': 'Main color',
  'apps.form.loginDisableUserAndPass': 'Disable user and password',
  'apps.form.loginDisableOffice365': 'Disable Office 365',
  'apps.form.loginDisableGoogle': 'Disable Google',
  'apps.form.loginDisableChangeToAutomy': 'Disable change to Automy',

  'apps.form.owner': 'Owner',

  // Auth mode (AppAuthMode)
  'apps.form.authMode': 'Authentication mode',
  'apps.form.authMode.automy': 'Automy',
  'apps.form.authMode.selfmanaged': 'Self-managed',

  // Builder
  'apps.builder.title': 'App Builder',
  'apps.builder.error.notFound': 'Application not found or does not exist',
  'apps.builder.chat.title': 'AI Assistant',
  'apps.builder.chat.placeholder': 'Describe what you want your application to have...',
  'apps.builder.chat.welcome':
    'I am your assistant for creating applications. Describe what kind of app you need and I will build it for you.',
  'apps.builder.preview': 'Preview',
  'apps.builder.code': 'Code',
  'apps.builder.noPreview': 'Your app starts here',
  'apps.builder.noPreview.description':
    'Describe what you need in the chat and the AI will build your application step by step',
  'apps.builder.noPreview.hint': 'Type in the chat to get started',
  'apps.builder.generating': 'Generating application...',
  'apps.builder.refresh': 'Refresh',
  'apps.builder.chat.subtitle': 'Create and modify your application',
  'apps.builder.chat.you': 'You',
  'apps.builder.chat.assistant': 'AI Assistant',
  'apps.builder.chat.thinking': 'Thinking...',
  'apps.builder.chat.error': 'Could not initialize chat',
  'apps.builder.chat.disclaimer': 'AI can generate inaccurate content. Verify the results.',
  'apps.builder.chat.noConnection': 'No connection. Try again.',
  'apps.builder.chat.open': 'Open chat',
  'apps.builder.chat.close': 'Close chat',
  'apps.builder.open': 'Open',
  'apps.builder.publish': 'Publish',
  'apps.builder.panel.saving': 'Saving...',
  'apps.builder.unsaved.indicator': 'Unsaved changes',
  'apps.builder.unsaved.confirm':
    'You have unsaved changes. Are you sure you want to leave and discard them?',
  'apps.builder.create.error': 'Could not create the app',
  'apps.builder.newApp.title': 'New App',
  'apps.builder.newApp.continue': 'Continue',
  'apps.builder.sidebar.overview': 'Overview',
  'apps.builder.section.basicInformation': 'Basic information',
  'apps.builder.section.personalization': 'Personalization',
  'apps.builder.section.manifest': 'Manifest',
  'apps.builder.section.login': 'Login',
  'apps.builder.section.permissions': 'Permissions',
  'apps.builder.section.accessControl': 'Access control',
  'apps.builder.publish.success': 'Application published successfully',
  'apps.builder.publish.error': 'Error publishing application',
  'apps.builder.setCurrent': 'Set as current',
  'apps.builder.setCurrent.success': 'Version set as current successfully',
  'apps.builder.setCurrent.error': 'Error setting version as current',
  'apps.builder.version.error': 'Error switching version',
  'apps.builder.version.publishedBy': 'Published by',
  'apps.builder.version.publishedDate': 'Date',
  'apps.builder.code.explorer': 'EXPLORER',
  'apps.builder.code.selectFile': 'Select a file to view its content',

  // View
  'apps.view.fullscreen': 'Fullscreen',
  'apps.view.exitFullscreen': 'Exit fullscreen',

  // Card
  'apps.card.active': 'Active',
  'apps.card.inactive': 'Inactive',
  'apps.card.createdBy': 'Created by',
  'apps.card.lastModified': 'Last modified',

  // Status
  'apps.status.active': 'Active',
  'apps.status.inactive': 'Inactive',

  // Process Form Drawer
  'apps.processForm.load.error': 'Error loading form',
  'apps.processForm.submit.success': 'Form submitted successfully',
  'apps.processForm.submit.error': 'Error submitting form',

  // Report Embed Drawer
  'apps.report.title': 'Report',
  'apps.report.load.error': 'Could not load the report',

  // App View Errors
  'apps.view.providerNotAvailable': 'Provider "{providerName}" not available',
  'apps.view.providerError': 'Provider error',
  'apps.view.loadError': 'Error loading app',

  // Code Viewer
  'apps.builder.code.explorer': 'EXPLORER',
  'apps.builder.code.selectFile': 'Select a file to view its content',

  // App View errors
  'apps.view.error.loading': 'Error loading app',
  'apps.view.error.providerNotAvailable': 'Provider "{providerName}" not available',
  'apps.view.error.providerError': 'Provider error',

  // Auth
  'apps.view.error.auth': 'You do not have access to this app or your session expired',

  // Not Published
  'apps.notPublished.title': 'App not published',
  'apps.notPublished.description':
    'This application does not have a published version yet. Open the builder to configure and publish it.',
  'apps.notPublished.back': 'Back to Apps',

  // PWA Install
  'apps.pwa.installPrompt': 'Install "{appName}" on your device',
  'apps.pwa.install': 'Install',

  // Common
  'apps.common.close': 'Close',

  // Offline
  'apps.offline.banner.offline':
    'You are offline. Changes will be saved locally and synced automatically.',
  'apps.offline.banner.syncing': 'Syncing pending changes...',
  'apps.offline.banner.pending': 'Connection restored. Pending changes: {count}.',
  'apps.offline.banner.failed': 'Some changes could not be synced: {count}.',
  'apps.offline.badge.offline': 'Offline',
  'apps.offline.badge.syncing': 'Syncing',
  'apps.offline.badge.pending': 'Pending: {count}',
  'apps.offline.badge.failed': 'Errors: {count}',
  'apps.offline.error.noCache': 'No connection and no offline cache is available.',
};
